"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WithdrawalLink = void 0;
var react_1 = __importDefault(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var WithdrawalLink = function (_a) {
    var t = _a.t, onClick = _a.onClick;
    return (react_1.default.createElement("div", { onClick: onClick, className: styles_module_scss_1.default.withdrawal }, t('withdrawal')));
};
exports.WithdrawalLink = WithdrawalLink;
